import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=4fba3132&lang=pug&"
import script from "./Breadcrumb.vue?vue&type=script&lang=js&"
export * from "./Breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fba3132')) {
      api.createRecord('4fba3132', component.options)
    } else {
      api.reload('4fba3132', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=4fba3132&lang=pug&", function () {
      api.rerender('4fba3132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Breadcrumb.vue"
export default component.exports